import { useCallback, useState } from 'react';
import { runBacktest } from '../engine/runBacktest';

function fingerprint(strategyId, params, barCount, positionMode, sizeMode, qty, maxRisk, startingBalance, pointValue, riskPercent, riskPercentBasis, tradeSession) {
  return JSON.stringify({ strategyId, params, barCount, positionMode, sizeMode, qty, maxRisk, startingBalance, pointValue, riskPercent, riskPercentBasis, tradeSession });
}

export function useBacktestRun() {
  const [result, setResult] = useState(null);
  const [ranKey, setRanKey] = useState(null);
  const [running, setRunning] = useState(false);
  const [error, setError] = useState(null);

  const run = useCallback(({ bars, strategy, params, unit, positionMode, sizeMode, qty, maxRisk, startingBalance, pointValue, riskPercent, riskPercentBasis, tradeSession, timeframes }) => {
    if (!strategy || !bars?.length) return null;
    setRunning(true);
    setError(null);
    try {
      const next = runBacktest({ bars, strategy, params, unit, positionMode, sizeMode, qty, maxRisk, startingBalance, pointValue, riskPercent, riskPercentBasis, tradeSession, timeframes });
      setRanKey(fingerprint(strategy.id, next.params, bars.length, positionMode, sizeMode, qty, maxRisk, startingBalance, pointValue, riskPercent, riskPercentBasis, tradeSession));
      setResult(next);
      return next;
    } catch (err) {
      setError(err?.message || 'Backtest failed');
      return null;
    } finally {
      setRunning(false);
    }
  }, []);

  const clear = useCallback(() => {
    setResult(null);
    setRanKey(null);
    setError(null);
  }, []);

  const isStale = useCallback((strategyId, params, barCount, positionMode, sizeMode, qty, maxRisk, startingBalance, pointValue, riskPercent, riskPercentBasis, tradeSession) => {
    if (!result) return false;
    return ranKey !== fingerprint(strategyId, params, barCount, positionMode, sizeMode, qty, maxRisk, startingBalance, pointValue, riskPercent, riskPercentBasis, tradeSession);
  }, [result, ranKey]);

  return { result, running, error, run, clear, isStale, ranKey };
}
